export const DateTimeFromMiliSeconds = (miliseconds) => {
	let seconds = miliseconds * 1000
	const options = {  month: 'long', day: 'numeric', hour:'numeric', minute:'numeric', second: 'numeric' };
	const date = new Date(seconds);
	const dateString = date.toLocaleDateString(undefined, options);
	return dateString;
};

export const DateFromMiliSeconds = (miliseconds) => {
	let seconds = miliseconds * 1000
	const options = {  month: 'long', day: 'numeric' };
	const date = new Date(seconds);
	const dateString = date.toLocaleDateString(undefined, options);
	return dateString;
};


